// AUTH
export const LOGIN_USER = "LOGIN_USER";
export const AUTO_LOGIN_CHECK = "AUTO_LOGIN_CHECK";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const GET_NEW_TOKEN = "GET_NEW_TOKEN";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const CHECK_EXPIRED_LINK = "CHECK_EXPIRED_LINK";
export const ADMIN_USER_LOGIN = "ADMIN_USER_LOGIN";
